export default {
  INVESTOR_PROFILE_ON_EMPLOYMENT_SITUATION_REPOSITORY: Symbol.for('INVESTOR_PROFILE_ON_EMPLOYMENT_SITUATION_REPOSITORY'),
  UPDATE_INVESTOR_PROFILE_ON_EMPLOYMENT_SITUATION_COMMAND: Symbol.for('UPDATE_INVESTOR_PROFILE_ON_EMPLOYMENT_SITUATION_COMMAND'),
};
